/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteTransferdisclaimerId } from '../fn/transfer-disclaimer/delete-transferdisclaimer-id';
import { DeleteTransferdisclaimerId$Params } from '../fn/transfer-disclaimer/delete-transferdisclaimer-id';
import { getTransferdisclaimer$Json } from '../fn/transfer-disclaimer/get-transferdisclaimer-json';
import { GetTransferdisclaimer$Json$Params } from '../fn/transfer-disclaimer/get-transferdisclaimer-json';
import { getTransferdisclaimer$Plain } from '../fn/transfer-disclaimer/get-transferdisclaimer-plain';
import { GetTransferdisclaimer$Plain$Params } from '../fn/transfer-disclaimer/get-transferdisclaimer-plain';
import { getTransferdisclaimerId$Json } from '../fn/transfer-disclaimer/get-transferdisclaimer-id-json';
import { GetTransferdisclaimerId$Json$Params } from '../fn/transfer-disclaimer/get-transferdisclaimer-id-json';
import { getTransferdisclaimerId$Plain } from '../fn/transfer-disclaimer/get-transferdisclaimer-id-plain';
import { GetTransferdisclaimerId$Plain$Params } from '../fn/transfer-disclaimer/get-transferdisclaimer-id-plain';
import { postTransferdisclaimer } from '../fn/transfer-disclaimer/post-transferdisclaimer';
import { PostTransferdisclaimer$Params } from '../fn/transfer-disclaimer/post-transferdisclaimer';
import { putTransferdisclaimerId } from '../fn/transfer-disclaimer/put-transferdisclaimer-id';
import { PutTransferdisclaimerId$Params } from '../fn/transfer-disclaimer/put-transferdisclaimer-id';
import { TransferDisclaimer } from '../models/transfer-disclaimer';

@Injectable({ providedIn: 'root' })
export class TransferDisclaimerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTransferdisclaimer()` */
  static readonly GetTransferdisclaimerPath = '/transferdisclaimer';

  /**
   * Retrieves transfer disclaimers.
   *
   * Retrieves transfer disclaimers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransferdisclaimer$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimer$Plain$Response(params?: GetTransferdisclaimer$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransferDisclaimer>>> {
    const obs = getTransferdisclaimer$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieves transfer disclaimers.
   *
   * Retrieves transfer disclaimers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransferdisclaimer$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimer$Plain(params?: GetTransferdisclaimer$Plain$Params, context?: HttpContext): Observable<Array<TransferDisclaimer>> {
    const resp = this.getTransferdisclaimer$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TransferDisclaimer>>): Array<TransferDisclaimer> => r.body)
    );
  }

  /**
   * Retrieves transfer disclaimers.
   *
   * Retrieves transfer disclaimers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransferdisclaimer$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimer$Json$Response(params?: GetTransferdisclaimer$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransferDisclaimer>>> {
    const obs = getTransferdisclaimer$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieves transfer disclaimers.
   *
   * Retrieves transfer disclaimers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransferdisclaimer$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimer$Json(params?: GetTransferdisclaimer$Json$Params, context?: HttpContext): Observable<Array<TransferDisclaimer>> {
    const resp = this.getTransferdisclaimer$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TransferDisclaimer>>): Array<TransferDisclaimer> => r.body)
    );
  }

  /** Path part for operation `postTransferdisclaimer()` */
  static readonly PostTransferdisclaimerPath = '/transferdisclaimer';

  /**
   * Creates a new transfer disclaimer.
   *
   * Creates a new transfer disclaimer..
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postTransferdisclaimer()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postTransferdisclaimer$Response(params?: PostTransferdisclaimer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postTransferdisclaimer(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new transfer disclaimer.
   *
   * Creates a new transfer disclaimer..
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postTransferdisclaimer$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postTransferdisclaimer(params?: PostTransferdisclaimer$Params, context?: HttpContext): Observable<void> {
    const resp = this.postTransferdisclaimer$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTransferdisclaimerId()` */
  static readonly GetTransferdisclaimerIdPath = '/transferdisclaimer/{id}';

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransferdisclaimerId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimerId$Plain$Response(params: GetTransferdisclaimerId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TransferDisclaimer>> {
    const obs = getTransferdisclaimerId$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransferdisclaimerId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimerId$Plain(params: GetTransferdisclaimerId$Plain$Params, context?: HttpContext): Observable<TransferDisclaimer> {
    const resp = this.getTransferdisclaimerId$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TransferDisclaimer>): TransferDisclaimer => r.body)
    );
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransferdisclaimerId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimerId$Json$Response(params: GetTransferdisclaimerId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TransferDisclaimer>> {
    const obs = getTransferdisclaimerId$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * API call to get a specific access number.
   *
   * API call to get a specific access number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransferdisclaimerId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransferdisclaimerId$Json(params: GetTransferdisclaimerId$Json$Params, context?: HttpContext): Observable<TransferDisclaimer> {
    const resp = this.getTransferdisclaimerId$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TransferDisclaimer>): TransferDisclaimer => r.body)
    );
  }

  /** Path part for operation `putTransferdisclaimerId()` */
  static readonly PutTransferdisclaimerIdPath = '/transferdisclaimer/{id}';

  /**
   * Updates details of a transfer disclaimer by ID.
   *
   * Updates details of a transfer disclaimer by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTransferdisclaimerId()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putTransferdisclaimerId$Response(params: PutTransferdisclaimerId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putTransferdisclaimerId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates details of a transfer disclaimer by ID.
   *
   * Updates details of a transfer disclaimer by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putTransferdisclaimerId$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putTransferdisclaimerId(params: PutTransferdisclaimerId$Params, context?: HttpContext): Observable<void> {
    const resp = this.putTransferdisclaimerId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTransferdisclaimerId()` */
  static readonly DeleteTransferdisclaimerIdPath = '/transferdisclaimer/{id}';

  /**
   * Deletes a transfer disclaimer by ID.
   *
   * Deletes a transfer disclaimer by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTransferdisclaimerId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTransferdisclaimerId$Response(params: DeleteTransferdisclaimerId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteTransferdisclaimerId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes a transfer disclaimer by ID.
   *
   * Deletes a transfer disclaimer by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTransferdisclaimerId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTransferdisclaimerId(params: DeleteTransferdisclaimerId$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteTransferdisclaimerId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
